import React, { HTMLAttributes } from 'react';
import cn from 'classnames';
// @ts-ignore
import { DFPSlotsProvider, AdSlot } from 'react-dfp';
import { getClientConfig } from '../../../../helpers';
import { getDynamicAdUnitPath } from '../../../../utils/advertising/getDynamicAdUnitPath';
import styles from './index.module.scss';

interface AdvertisingProps extends HTMLAttributes<HTMLDivElement> {
  advSlots: string[];
  advSize: string;
  networkId: string;
  adUnit: string;
  pageCategory?: string;
}

export default function Advertising(props: AdvertisingProps) {
  const {
    advSlots,
    advSize,
    networkId,
    adUnit,
    pageCategory,
    className,
    ...elementProps
  } = props;
  const { advertising } = getClientConfig();
  const { sizeMapping, sizes } = advertising[advSize];
  const adUnitPath = getDynamicAdUnitPath({
    adUnit,
    pageCategory,
  });

  return (
    <div {...elementProps} className={cn(styles.wrapper, className)}>
      <DFPSlotsProvider
        dfpNetworkId={networkId}
        sizeMapping={sizeMapping}
        collapseEmptyDivs
      >
        {advSlots.map((slotId, i) => (
          <div key={i} data-testid={`advertising-slot-${slotId}-${i}`}>
            <AdSlot
              adUnit={adUnitPath}
              sizes={sizes}
              sizeMapping={sizeMapping}
              slotId={slotId}
              targetingArguments={{ pos: slotId }}
            />
          </div>
        ))}
      </DFPSlotsProvider>
    </div>
  );
}
